import { Amount, Consent, Transaction } from '~/types';
import axios, { ResponseType } from './axios';

export interface PayoutConsentData {
  senderAccountId: string;
  localUTCOffset?: string;
  amount: Amount;
  service: {
    id: string;
    parameters: Record<string, string | number>;
  };
  comment?: string;
}

export const createPayoutConsent = (body: PayoutConsentData): ResponseType<Consent> => {
  return axios.post('/payments/payout/consent', body);
};

export const updatePayoutConsent = (
  consentId: string,
  body: PayoutConsentData
): ResponseType<Consent> => {
  return axios.put(`/payments/payout/consent/${consentId}`, body);
};

export const makePayoutTransfer = (consentId: string): ResponseType<Transaction> => {
  return axios.post(`/payments/payout`, { consentId });
};
